import React from "react";
import PropTypes from "prop-types";

import FinancialRow from "./FinancialRow";

const TotalRow = ({
  displayName,
  financialDataFieldName,
  financialData,
  classes,
  isNegative,
}) => (
  <FinancialRow
    displayName={displayName}
    financialDataFieldName={financialDataFieldName}
    financialData={financialData}
    classes={classes}
    insertDivider
    bold
    underlined={false}
    isNegative={isNegative}
    hasLeftMargin
    hasVerticalSpacing
  />
);

TotalRow.propTypes = {
  displayName: PropTypes.string.isRequired,
  financialDataFieldName: PropTypes.string.isRequired,
  financialData: PropTypes.shape({
    years: PropTypes.arrayOf(
      PropTypes.shape({
        year: PropTypes.number.isRequired,
      })
    ),
    cumulative: PropTypes.objectOf(PropTypes.number),
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- See financialTableStyles
  classes: PropTypes.object.isRequired,
  isNegative: PropTypes.bool,
};

TotalRow.defaultProps = {
  isNegative: false,
};

export default TotalRow;
